var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VRow',[_c('VCol',{attrs:{"col":"12"}},[_c('VCard',[_c('VCardTitle',[_vm._v("JET")]),_c('VCardText',[_c('VFormBuilder',{ref:"form",attrs:{"items":_vm.items,"initial-values":_vm.internalInitialValues}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }